import React from 'react';

export default class ErrorView extends React.Component {
    render() {
        return <div>{this.props.error}</div>;
    }
}
